import React from 'react';
import { motion } from 'framer-motion';
export function WineSection() {
  return <section id="vinos" className="py-24 bg-laura-cream text-laura-dark" data-id="element-324">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-325">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-326">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8
        }} className="order-2 lg:order-1" data-id="element-327">
            <span className="text-laura-olive text-sm font-bold uppercase tracking-[0.2em] mb-4 block" data-id="element-328">
              Nuestra Bodega
            </span>
            <h2 className="text-4xl md:text-5xl font-playfair text-laura-wood mb-8 leading-tight" data-id="element-329">
              Vinos con carácter
            </h2>

            <div className="space-y-6 text-lg text-laura-wood/80 font-light leading-relaxed" data-id="element-330">
              <p data-id="element-331">
                Contamos con una cuidada selección de vinos, con especial
                protagonismo para los vinos de la zona de Madrid, Chinchón y
                Villaconejos.
              </p>
              <p data-id="element-332">
                También trabajamos con Rioja, Ribera del Duero y una selección
                de vinos experimentales envejecidos bajo el mar en cava
                submarina, una experiencia única para los amantes del vino.
              </p>
              <p data-id="element-333">
                Nuestra bodega, ubicada en la cueva del restaurante, es el lugar
                perfecto para disfrutar de una copa antes de la comida.
              </p>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="order-1 lg:order-2 relative" data-id="element-334">
            <div className="absolute -inset-4 border-2 border-laura-olive/30 rounded-lg transform translate-x-4 translate-y-4 -z-10" data-id="element-335" />
            <img src="https://cdn.magicpatterns.com/uploads/7fpb4fogSxx8dPsXuDcZ9N/VISITA.jpg" alt="Visita a la bodega de El Rincón de Laura" className="w-full h-auto object-cover rounded-lg shadow-xl" data-id="element-336" />
          </motion.div>
        </div>
      </div>
    </section>;
}